<template>
    <div class="c-a-select" :class="{'c-a-select--invalid': invalid}">
        <label class="c-a-select__label" :for="`question-${id}`">{{label}}<span v-if="required"> *</span></label>
        <div class="c-a-select__wrapper" :class="{'c-a-select__wrapper--with-icon' : icon}">
            <icon v-if="icon" class="c-a-select__icon c-a-select__icon--symbol" :icon="icon"></icon>
            <select
                :id="`question-${id}`"
                :name="`question-${id}`"
                class="c-a-select__select"
                :class="{'c-a-select__select--placeholder': selected === ''}"
                v-model="selected"
                v-on:change="updated"
            >
                <option v-if="placeholder" class="c-a-select__placeholder" :value="''">{{placeholder}}</option>
                <option v-else class="c-a-select__placeholder" :value="''">-- Välj --</option>
                <option v-for="(option, index) in alternatives" :value="option" :key="`option-${index}`">{{option.text}}</option>
            </select>
            <span class="c-a-select__button">
                <icon :icon="'expand_more'"></icon>
            </span>
        </div>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue'

    export default {
        props: {
            id: Number,
            label: String,
            invalid: Boolean,
            required: Boolean,
            alternatives: Array,
            icon: String,
            dataKey: String,
            defaultValue: Object,
            placeholder: String
        },
        data() {
            return {
                selected: ''
            }
        },
        components: {
            Icon
        },
        methods:{
            updated(){
                const data = {
                    questionId: this.id,
                    label: this.label,
                    answers: this.selected,
                    multi: false
                };

                if(this.dataKey){
                    data.dataKey = this.dataKey;
                }

                this.$emit('updateData', data);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomSelectRequestForm.vue